// import React from "react";
// import { useEffect } from "react";
// import { useRef } from "react";
// import { useState } from "react";
// import { MdArrowBack } from "react-icons/md";

// import ConfirmPassword from "./ConfirmPassword";
// import classes from "./ForgotPassword.module.css";
// import OtpVerification from "./OtpVerification";

// let buttonValue = "Send OTP";
// let jay = 0;
// let apiMsg = "";
// let flag = false;
// let OTP = "";
// const ForgotPassword = (props) => {
//   const [isSendOtpClicked, setIsSendOtpClicked] = useState(false);
//   const [isVerifyClicked, setIsVerifyClicked] = useState();
//   const [isCall, setIsCall] = useState();
//   const [isResponse, setIsResponse] = useState();
//   const [isError, setIsError] = useState();
//   const emailInputRef = useRef();
//   const otpInputRef = useRef();

//   useEffect(() => {
//     function myFunc() {
//       // console.log("loading...");
//       // buttonValue = "Loading..."
//       var myHeaders = new Headers();
//       myHeaders.append("Content-Type", "application/json");

//       var raw = JSON.stringify({
//         emailID: emailInputRef.current.value,
//         eventID: "1",
//       });

//       var requestOptions = {
//         method: "POST",
//         headers: myHeaders,
//         body: raw,
//         redirect: "follow",
//       };

//       fetch("/api/v1/Authentication/AuthenticateOTP", requestOptions)
//         .then((response) => response.text())
//         .then((result) => {
//           OTP = JSON.parse(result).OTP;
//           JSON.parse(result).Message === "Success"
//             ? setIsResponse("success")
//             : setIsResponse("fail");
//         })
//         .catch((error) => console.log("error", error));
//       // console.log("loading completed");
//     }
//     if (jay > 1) myFunc();
//     jay++;
//   }, [isCall]);

//   if (!flag) {
//     if (isResponse === "success") {
//       setTimeout(() => {
//         buttonValue = "Verify";
//         // alert("1");
//         setIsSendOtpClicked(true);
//       });
//       flag = true;
//     }
//   }

//   const sendOtpClickHandler = (e) => {
//     e.preventDefault();
//     const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//     // if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
//     if (emailRegex.test(emailInputRef?.current?.value)) {
//       if (buttonValue === "Verify") {
//         // alert(OTP);
//         if (otpInputRef.current.value == OTP) {
//           setIsVerifyClicked(true);
//           buttonValue = "Go to Login Page";
//           setIsError("");
//         } else setIsError("Wrong OTP");
//       } else {
//         setIsCall((prev) => !prev);
//         flag = false;
//         // buttonValue = "Verify";
//         // setIsSendOtpClicked(true);
//         setIsError("");
//       }
//     } else {
//       setIsError("Please Enter Valid Email");
//     }
//   };
//   const backClickHandler = () => {
//     if (buttonValue === "Send OTP") {
//       props.forgotPassword(false);
//     } else if (buttonValue === "Verify") {
//       setIsVerifyClicked(false);
//       setIsSendOtpClicked(false);
//       buttonValue = "Send OTP";
//     } else if (buttonValue === "Go to Login Page") {
//       buttonValue = "Send OTP";
//       setIsSendOtpClicked(false);
//       setIsVerifyClicked(false);
//     }
//   };
//   return (
//     <div>
//       {/* <MdArrowBack
//         className={classes.backArrow}
//         onClick={backClickHandler}
//       /> */}
//       {isResponse === "fail" && (
//         <p style={{ color: "red" }}>Email does not Exist</p>
//       )}
//       {isError && <p style={{ color: "red" }}>{isError}</p>}
//       {!isVerifyClicked && (
//         <div id="form">
//           <input
//             type="text"
//             placeholder="Enter Your Registered Email"
//             id="input"
//             ref={emailInputRef}
//           />
//           {console.log(isSendOtpClicked)}
//           {isSendOtpClicked && (
//             <input
//               type="number"
//               placeholder="Enter OTP"
//               id="input"
//               ref={otpInputRef}
//             />
//             // <OtpVerification />
//           )}
//           <input
//             type="submit"
//             value={buttonValue}
//             id="loginButton"
//             onClick={sendOtpClickHandler}
//           />
//         </div>
//       )}
//       {isVerifyClicked && (
//         <ConfirmPassword
//           email={emailInputRef.current.value}
//           forgotPassword={props.forgotPassword}
//         />
//       )}
//     </div>
//   );
// };

// export default ForgotPassword;

import React, { useEffect, useRef, useState } from "react";
import ConfirmPassword from "./ConfirmPassword";
import useHttp from "../../Hooks/use-http";

const ForgotPassword = (props) => {
  const [isSendOtpClicked, setIsSendOtpClicked] = useState(false);
  const [isVerifyClicked, setIsVerifyClicked] = useState(false);
  const [isResponse, setIsResponse] = useState(null);
  const [isError, setIsError] = useState(null);
  const [otp, setOtp] = useState("");
  const emailInputRef = useRef();
  const otpInputRef = useRef();
  const [buttonValue, setButtonValue] = useState("Send OTP");
  const { sendRequest } = useHttp();

  useEffect(() => {
    if (!isSendOtpClicked) return;

    sendRequest(
      {
        url: "/AuthenticateOTP",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: emailInputRef.current.value || "",
          eventID: "1",
        },
      },
      (response) => {
        setOtp(response.OTP);
        if (response.Message === "Success") {
          setIsResponse("success");
          setButtonValue("Verify");
        } else {
          setIsResponse("fail");
        }
      },
      (error) => {
        console.error("Error:", error);
        setIsResponse("fail");
      }
    );
  }, [isSendOtpClicked]);

  const sendOtpClickHandler = (e) => {
    e.preventDefault();
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(emailInputRef?.current?.value)) {
      setIsError("Please Enter a Valid Email");
      return;
    }

    // if (buttonValue === "Verify") {
    //   // if (otpInputRef.current.value === otp) {
    //   //   setIsVerifyClicked(true);
    //   //   setButtonValue("Go to Login Page");
    //   //   setIsError(null);
    //   // } else {
    //   //   setIsError("Wrong OTP");
    //   // }

    // }
    if (buttonValue === "Verify") {
      verifyOtpHandler();
    } else {
      setIsSendOtpClicked(true);
      setIsError(null);
    }

    // else {
    //   setIsSendOtpClicked(true);
    //   setIsError(null);
    // }
  };

  const verifyOtpHandler = async () => {
    if (!otpInputRef?.current?.value) {
      setIsError("Please enter the OTP");
      return;
    }

    sendRequest(
      {
        url: "/VerifyOTP",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: emailInputRef.current.value || "",
          otpNumber: otpInputRef.current.value || "",
        },
      },
      (response) => {
        if (response.Message === "Success") {
          setIsVerifyClicked(true);
          setButtonValue("Go to Login Page");
          setIsError(null);
        } else {
          setIsError("Invalid OTP");
        }
      },
      (error) => {
        console.error("Error:", error);
        setIsError("OTP verification failed. Try again.");
      }
    );
  };

  const backClickHandler = () => {
    if (buttonValue === "Send OTP") {
      props.forgotPassword(false);
    } else {
      setIsVerifyClicked(false);
      setIsSendOtpClicked(false);
      setButtonValue("Send OTP");
    }
  };

  return (
    <div>
      {isResponse === "fail" && (
        <p style={{ color: "red" }}>Email does not exist</p>
      )}
      {isError && <p style={{ color: "red" }}>{isError}</p>}

      {!isVerifyClicked ? (
        <div id="form">
          <input
            type="text"
            placeholder="Enter Your Registered Email"
            id="input"
            ref={emailInputRef}
          />
          {isSendOtpClicked && (
            <input
              type="number"
              placeholder="Enter OTP"
              id="input"
              ref={otpInputRef}
            />
          )}
          <input
            type="submit"
            value={buttonValue}
            id="loginButton"
            onClick={sendOtpClickHandler}
          />
        </div>
      ) : (
        <ConfirmPassword
          email={emailInputRef?.current?.value}
          forgotPassword={props?.forgotPassword}
        />
      )}
    </div>
  );
};

export default ForgotPassword;
